import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React from 'react';
interface IcolorPallete {
  borderColor: string;
  backgroundColor: string;
  iconColor: string;
}
interface AlertProps {
  label: string;
  description: JSX.Element;
  icon: string;
  colorPallete: IcolorPallete;
  closeAction?: () => void;
}

const Alert = ({
  label,
  colorPallete,
  description,
  icon,
  closeAction,
}: AlertProps) => {
  return (
    <div
      className={classNames(
        ' border-[1px]  px-3 py-3 gap-1  rounded relative flex flex-col',
        colorPallete.backgroundColor,
        colorPallete.borderColor,
      )}
      role="alert"
    >
      <div className="flex w-full justify-between pb-2 ">
        <SpanIcon
          className={classNames(' text-xxl ', icon, colorPallete.iconColor)}
        />
        {closeAction && (
          <div onClick={() => closeAction()}>
            <SpanIcon
              className={classNames(
                'icon-nameClose-remove text-xl text-green-500',
                colorPallete.iconColor,
              )}
            />
          </div>
        )}
      </div>
      <h5 className="text-gray-900 text-sm font-Medium  m-0 p-0">{label}</h5>
      <p className="text-gray-900 text-sm font-Regular m-0 p-0">
        {description}
      </p>
    </div>
  );
};

export default Alert;
